import SiteHeader from '../features/headers/site-header';
import SiteFooter from '../features/footer/site-footer';
import NotFound from '../features/not-found/not-found';

export default function NotFoundPage() {
    return (
        <>
            <a className="skip-link" href="#contenido">Saltar al contenido</a>
            <SiteHeader />
            <main id="contenido">
                <NotFound />
            </main>
            <SiteFooter />
        </>
    );
}
